export default __webpack_public_path__ + "static/media/browserify.2c1eda8d.svg";